import { Pipe, PipeTransform } from '@angular/core';
import { SubRegion } from '@app/shared/classes/subRegion';

@Pipe({
  name: 'subRegionNamesTranslate',
  standalone: true
})
export class SubRegionNamesTranslate implements PipeTransform {
  transform(value: number[], subRegionList: SubRegion[]) {
    if (value && value.length > 0) {
      return value
        .map(item => subRegionList.find(subRegion => subRegion.subRegion_Id === item))
        .filter(item => item)
        .map(item => item.subRegionName)
        .join(',');
    }

    return ''
  }
}
